import Customer from "../../../../Models/Customer";
import Mediator from "../../../../Utilities/Mediator";
import RegexHandler from "../../../../Utilities/RegexHandler";
import OrderHandler from "../../OrderHandler";

export default class AutoCompleteTile {
	customer: Customer;
	resultsWrapper: HTMLDivElement;
	searchValue: string;

	constructor(customer: Customer, resultsWrapperDiv: HTMLDivElement, searchValue: string) {
		this.customer = customer;
		this.resultsWrapper = resultsWrapperDiv;
		this.searchValue = searchValue;

		this.init();
	}

	private init() {
		const resultDiv: HTMLDivElement = this.createAutoCompleteTile();

		resultDiv.onclick = () => {
			this.fillInputs(resultDiv);
		}

		this.resultsWrapper.appendChild(resultDiv);
	}

	private createAutoCompleteTile(): HTMLDivElement {
		const escapedSearchValue = RegexHandler.escapeRegex(this.searchValue);
		const regex = new RegExp(escapedSearchValue, "gi");
		const autocompleteTile = document.createElement('div');
		const separator = document.createElement('br');
		const userIcon = document.createElement('i');
		const phoneSection = document.createElement('span');
		const phoneIcon = document.createElement('i');
		const inputValue = document.createElement('input');

		userIcon.classList.add("icon-user");
		autocompleteTile.appendChild(userIcon);
		autocompleteTile.innerHTML += " ";
		autocompleteTile.innerHTML += this.customer.name.replace(regex, "<b>$&</b>");
		phoneIcon.classList.add("icon-phone-sign");

		autocompleteTile.appendChild(separator);
		phoneSection.appendChild(phoneIcon);
		phoneSection.innerHTML += " ";
		phoneSection.innerHTML += this.customer.phoneNumber.replace(regex, "<b>$&</b>");

		inputValue.type = "hidden";
		inputValue.value = `${this.customer.name}    ${this.customer.phoneNumber}`;

		autocompleteTile.appendChild(phoneSection);
		autocompleteTile.appendChild(inputValue);

		return autocompleteTile;
	}

	private fillInputs(selectedDiv: HTMLDivElement) {
		const nameInput: HTMLInputElement = document.querySelector("#create-customer-inputs input[name='name']");
		const phoneInput: HTMLInputElement = document.querySelector("#phone");

		nameInput.value = selectedDiv.querySelector("input").value.split('    ')[0] ?? "";
		phoneInput.value = selectedDiv.querySelector("input").value.split('    ')[1] ?? "";

		OrderHandler.order.customerName = nameInput.value;
		OrderHandler.order.customerPhoneNumber = phoneInput.value;

		Mediator.emit("customerSelected");
	}
}
